// extracted by mini-css-extract-plugin
module.exports = {"component":"GutterBox_component__3NbYW"};